module.exports = __webpack_public_path__ + "static/TiemposTextWeb-Regular-821e5a87cbda4336a064b69982ed312a.woff";